import { PlusCircleOutlined } from '@ant-design/icons';
import { ModalAlert } from '@molecules';
import { Button, Col, Row, Typography } from 'antd';
import { useCallback, useState } from 'react';
import { useFieldArray, useFormContext, useFormState } from 'react-hook-form';

import { TenantFormData } from 'src/features/tenants/types/tenantForm.types';

import { TenantFormSection } from '../formSection.types';
import { DomainsList } from './components/DomainsList';

const keyName = '_id';
export const DomainsForm: TenantFormSection = () => {
  const { control, setValue, getValues } = useFormContext<TenantFormData>();
  const { errors } = useFormState<TenantFormData>();
  const [domainToDelete, setDomainToDelete] = useState<
    { index: number; id?: number } | undefined
  >(undefined);
  const {
    append: appendDomains,
    remove: removeAddField,
    fields: addFields,
    update: updateAdd,
  } = useFieldArray({
    keyName,
    control,
    name: 'domains.add',
  });

  const { fields: editFields, update: updateEdit } = useFieldArray({
    keyName,
    control,
    name: 'domains.edit',
  });

  const handleDeleteEditDomain = useCallback((_: any, id?: number) => {
    if (!id) return;
    const toRemove = getValues('domains.delete') ?? [];
    toRemove.push(id);
    setValue('domains.delete', toRemove);
  }, []);

  const handleDeleteAddDomain = useCallback((index: number) => {
    removeAddField(index);
  }, []);

  const handleUnMarkAsPrimary = (index: number, id?: number) => {
    if (id) {
      updateEdit(index, {
        ...editFields[index],
        isPrimary: false,
      });
    } else {
      updateAdd(index, {
        ...addFields[index],
        isPrimary: false,
      });
    }
  };

  const searchAndRemovePrimary = () => {
    const isPrimaryEditIndex = editFields.findIndex(domain => domain.isPrimary);
    if (isPrimaryEditIndex > -1)
      updateEdit(isPrimaryEditIndex, {
        ...getValues(`domains.edit.${isPrimaryEditIndex}`),
        isPrimary: false,
      });

    const isPrimaryAddIndex = addFields.findIndex(domain => domain.isPrimary);
    if (isPrimaryAddIndex > -1)
      updateAdd(isPrimaryAddIndex, {
        ...getValues(`domains.add.${isPrimaryAddIndex}`),
        isPrimary: false,
      });
  };

  const handleMarkAsPrimary = (index: number, id?: number) => {
    if (id) {
      searchAndRemovePrimary();

      updateEdit(index, {
        ...getValues(`domains.edit.${index}`),
        isPrimary: true,
      });
      return;
    }
    searchAndRemovePrimary();

    updateAdd(index, {
      ...getValues(`domains.add.${index}`),
      isPrimary: true,
    });
  };

  return (
    <>
      {errors['domains']?.type === 'at-least-one-primary-domain' && (
        <Row style={{ marginBlockEnd: 16 }}>
          <Typography.Text type='danger'>
            {errors['domains']?.message}
          </Typography.Text>
        </Row>
      )}
      {DomainsList({
        domainField: 'edit',
        onDelete: (index, id) => setDomainToDelete({ index, id }),
        onMarkAsPrimary: handleMarkAsPrimary,
        onUnMarkAsPrimary: handleUnMarkAsPrimary,
        fields: editFields,
      }).map(EditSetting => EditSetting)}

      {DomainsList({
        domainField: 'add',
        onDelete: index => setDomainToDelete({ index }),
        onMarkAsPrimary: handleMarkAsPrimary,
        onUnMarkAsPrimary: handleUnMarkAsPrimary,
        fields: addFields,
      }).map(AddSetting => AddSetting)}
      <Row justify='center'>
        <Col>
          <Button
            type='text'
            style={{ color: '#177DDC' }}
            icon={<PlusCircleOutlined />}
            onClick={() => {
              appendDomains({
                domain: '',
                isPrimary: false,
              });
            }}
          >
            Adicionar domínio
          </Button>
        </Col>
      </Row>
      <ModalAlert
        showModal={Boolean(domainToDelete)}
        confirmButtonAction={() => {
          if (!domainToDelete) return;
          const { index, id } = domainToDelete;
          if (id) {
            handleDeleteEditDomain(index, id);
          } else {
            handleDeleteAddDomain(index);
          }
          setDomainToDelete(undefined);
        }}
        denyButtonAction={() => {
          setDomainToDelete(undefined);
        }}
        titleLabel={'Excluir Domínio'}
        messageLabel='Tem certeza que deseja excluir esse domínio?'
      />
    </>
  );
};
